<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Awards</div>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 600px; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Award</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <awardsForm
            ref="editForm"
            :id="viewFormData.id"
            @close="close"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import awardsForm from "@/components/awards/awardsForm.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      awardsForm,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        gridData: "awards/list",
        dataLoading: "awards/listLoading",
        questionRangeOptions: "settings/questionRangeOptions",
        questionRangeTypes: "settings/questionRangeTypes",
      }),
    },
    data: () => ({
      // data-table
      columns: [
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          style:
            "min-width: 250px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "shortName",
          label: "Short Name",
          align: "left",
          field: "shortName",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "expiryType",
          label: "Expiry Type",
          align: "left",
          field: "typeExpiry",
          format: (val) => {
            return val == 1 ? "Y" : "N";
          },
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "created_at",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) =>
            val != null ? moment.utc(val).local().format("DD-MMM, YYYY") : "",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "updated_at",
          label: "Updated At",
          align: "left",
          field: "updated_at",
          format: (val) =>
            val != null ? moment.utc(val).local().format("DD-MMM, YYYY") : "",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
      ],
      search: "",

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,

      // Deleting Codes
      deletingDQCodes: null,
    }),
    watch: {
      $route: function () {
        this.handleRoute();
      },
    },
    mounted() {
      this.loadData();
      this.handleRoute();
    },
    methods: {
      handleDoubleClick(row) {
        this.$router.push(`${this.$route.path}/${row.id}`);
      },
      loadData() {
        this.$store.dispatch("awards/loadAll");
      },
      handleRoute() {
        if (this.$route.params.id) {
          this.viewFormData = { id: this.$route.params.id };
          this.$nextTick(() => {
            this.viewDetailsDialog = true;
          });
        } else {
          this.viewDetailsDialog = false;
        }
      },
      close() {
        this.$router.push("/management/awards");
      },
    },
  };
</script>

<style lang="scss" scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .formHeight {
    min-height: calc(100vh - 175px);
    max-height: 1000px;
  }
</style>
